'use client';

import VerticalIcon from './Vertical.js';
import MoreIcon from './More.js';
import CloseIcon from './Close.js';
import ExpandIcon from './Expand.js';
import CollapseIcon from './Collapse.js';
import NextIcon from './Next.js';
import BackIcon from './Back.js';
import ExternalLinkIcon from './ExternalLink.js';
import RightArrowIcon from './RightArrow.js';

var Navigation = {
    VerticalIcon: VerticalIcon,
    MoreIcon: MoreIcon,
    CloseIcon: CloseIcon,
    ExpandIcon: ExpandIcon,
    CollapseIcon: CollapseIcon,
    NextIcon: NextIcon,
    BackIcon: BackIcon,
    ExternalLinkIcon: ExternalLinkIcon,
    RightArrowIcon: RightArrowIcon
};

export { Navigation as default };
//# sourceMappingURL=index.js.map
